import React from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../../components/shared/Modal';
import './styles_Modal.Product.scss';
import { ModifyProductModal } from '../../../components/ATQ/ATQ_CONSUM_REPORT/ATQ_Modals/ModifyProductModal';


export const ATQ_Modify_Product = (props) => {
  
    const modalBody = () => {
        return (
        <ModifyProductModal     
            toggle={props.toggle}
            setOpenModal={props.setOpenModal}
            setCxSelected  = {props.setCxSelected}

        />
    );
    };

    return (
        <CustomModal
                isOpen={props.isOpen}
                toggle={props.toggle} 
                body={modalBody()}
        />
    );
}

ATQ_Modify_Product.propTypes = {
    isOpen: PropTypes.any,
    toggle: PropTypes.any,
};